import React, { Component } from 'react';
import { connect } from 'react-redux';
import { signIn, signOut } from '../actions';
import history from '../history';

class GoogleAuth extends Component {

	componentDidMount() {
		window.gapi.load('client:auth2', () => {
			window.gapi.client.init({
				clientId: '771150846170-jq3smtkknemcohkar6bjqcg272epe0j0.apps.googleusercontent.com',
				scope: 'email'
			}).then(() => {
				this.auth = window.gapi.auth2.getAuthInstance();
				this.onAuthChange(this.auth.isSignedIn.get());
				this.auth.isSignedIn.listen(this.onAuthChange);
			});
		});
	}

	onAuthChange = (isSignedin) => {
		if(isSignedin) {
			this.props.signIn(this.auth.currentUser.get().getId());
		} else {
			this.props.signOut();
		}
	};

	onSignInClick = () => {
		this.auth.signIn();
		history.push('/create');
	};

	onSignOutClick = () => {
		this.auth.signOut();
	};

	renderAuthButton() {
		if(this.props.isSignedin === null){
			return   <div className="ui active inline loader"></div>;
		} else if(this.props.isSignedin) {
			return <button className="ui red google button" onClick={this.onSignOutClick}><i className="google icon"/>Sign Out</button>;
		} else {
			return <button className="ui red google button" onClick={this.onSignInClick}><i className="google icon"/>Sign In</button>;
		}
	}

	render() {
		return(<div>{this.renderAuthButton()}</div>);
	}
}

const mapStateToProps = (state) => {
	return {
		isSignedin: state.auth.isSignedIn
	};
};

export default connect(mapStateToProps, { signIn, signOut })(GoogleAuth);